var map = {
	"./about-icon1.svg": 7089,
	"./about-icon2.svg": 6690,
	"./about-icon3.svg": 7267,
	"./about-icon4.svg": 524,
	"./checkbox-off.svg": 5688,
	"./checkbox-on.svg": 2,
	"./derivative-icon1.svg": 9027,
	"./derivative-icon2.svg": 8272,
	"./derivative-icon3.svg": 7873,
	"./derivative-icon4.svg": 5726,
	"./feature-icon1.svg": 3828,
	"./feature-icon2.svg": 8391,
	"./feature-icon3.svg": 4566,
	"./feature-icon4.svg": 4601,
	"./feature-icon5.svg": 9208,
	"./feature-icon6.svg": 9947,
	"./hts-icon1.svg": 4801,
	"./hts-icon2.svg": 1666,
	"./hts-icon3.svg": 6307,
	"./icon-chevron.svg": 714,
	"./icon-close.svg": 9827,
	"./icon-mail.svg": 652,
	"./language.svg": 8997,
	"./mobileTrading-icon1.svg": 1023,
	"./mobileTrading-icon2.svg": 1996,
	"./mobileTrading-icon3.svg": 7453,
	"./mobileTrading-icon4.svg": 8162,
	"./order-icon1.svg": 4878,
	"./order-icon2.svg": 3229,
	"./order-icon3.svg": 4284,
	"./risk-icon1.svg": 8709,
	"./risk-icon2.svg": 2486,
	"./risk-icon3.svg": 5287,
	"./shortselling-icon1.svg": 2706,
	"./shortselling-icon2.svg": 7249,
	"./shortselling-icon3.svg": 4448,
	"./shortselling-icon4.svg": 3007,
	"./signal-icon10.svg": 4416,
	"./signal-icon4.svg": 2429,
	"./signal-icon5.svg": 620,
	"./signal-icon6.svg": 9647,
	"./signal-icon7.svg": 1710,
	"./signal-icon8.svg": 2265,
	"./signal-icon9.svg": 6760,
	"./swiper-next.svg": 1803,
	"./swiper-prev.svg": 8887,
	"./tap-icon1.svg": 5741,
	"./tap-icon2.svg": 6622,
	"./tap-icon3.svg": 7727,
	"./tap-icon4.svg": 9168,
	"./tap-icon5.svg": 1969,
	"./tap-icon6.svg": 7426,
	"./tap-icon7.svg": 67,
	"./tradingsoft-icon1.svg": 6465,
	"./tradingsoft-icon2.svg": 6978,
	"./tradingsoft-icon3.svg": 1619,
	"./tradingsoft-icon4.svg": 1436,
	"./wtt-icon1.svg": 8201,
	"./wtt-icon10.svg": 4363,
	"./wtt-icon11.svg": 3994,
	"./wtt-icon12.svg": 5369,
	"./wtt-icon13.svg": 9976,
	"./wtt-icon2.svg": 3738,
	"./wtt-icon3.svg": 4699,
	"./wtt-icon4.svg": 20,
	"./wtt-icon5.svg": 1189,
	"./wtt-icon6.svg": 8758,
	"./wtt-icon7.svg": 3143,
	"./wtt-icon8.svg": 960,
	"./wtt-icon9.svg": 6913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;